import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/ProcessMetricsOcr.graphql';
import { Mutation, MutationprocessMetricsOcrArgs } from '../../__generated__/globalTypes';

export const useProcessMetricsOcrMutation = (
  options?: MutationHookOptions<Mutation, MutationprocessMetricsOcrArgs>
) => {
  const [callProcessMetricsOcr, result] = useMutation<Mutation, MutationprocessMetricsOcrArgs>(MUTATION, options);

  return { callProcessMetricsOcr, ...result };
};

export type ProcessMetricsOcrMutationFunction = Mutation['processMetricsOcr'];
